import React, { Fragment } from 'react'

const SelectFieldReservation = ({ name, value, data, onChange, error,reference }) => {
    
    return (
        <Fragment>
            <select className="form-control" name={name} value={value} onChange={onChange} ref={reference}>
                {data.map((row, i) => <option key={i} value={row.date}>{row.date}</option>)}
            </select>
            {error !== undefined && (<label className="error-label">{error}</label>)}
        </Fragment>
    )
}

export default SelectFieldReservation